import React from 'react';
import fetchJsonp from 'fetch-jsonp';
import loadScript from 'load-script';
import rawMarkup from '../util/rawMarkup';

const INSTAGRAM_JS_PATH = '//platform.instagram.com/en_US/embeds.js';
const INSTAGRAM_API_PATH = 'https://api.instagram.com/oembed/';
const INSTAGRAM_MAXWIDTH = 420;

export default class InstagramRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { html: null };
  }

  componentDidMount() {
    this.fetchInstagramPost(this.props.id);
  }

  componentWillReceiveProps({ id }) {
    if (this.props.id !== id) {
      this.fetchInstagramPost(id);
    }
  }

  componentDidUpdate() {
    // TODO: Check console for errors such as 'cannot call method process of undefined'
    if (this.state.html) {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      } else {
        loadScript(INSTAGRAM_JS_PATH);
      }
    }
  }

  fetchInstagramPost(id) {
    fetchJsonp(`${INSTAGRAM_API_PATH}?url=http://instagr.am/p/${id}`)
      .then(response => response.json())
      .then(result => this.setState({ html: result.html }));
  }

  render() {
    return this.state.html &&
      <div style={{ maxWidth: INSTAGRAM_MAXWIDTH, margin: '0 auto' }} dangerouslySetInnerHTML={rawMarkup(this.state.html)} />;
  }
}

InstagramRenderer.propTypes = {
  id: React.PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/component/InstagramRenderer.jsx